module.exports = __webpack_public_path__ + "static/media/09.Stage Set up.1e575531.JPG";